import { BaseApi } from "api/BaseApi";
import { ApiResponse } from "types/models.ts";

class SanctumApi extends BaseApi {
    /**
     * Get CSRF cookie
     *
     * - Request: -
     * - Response: 204 No Content
     */
    async getCsrfCookie(): Promise<ApiResponse<null>> {
        return await this.getRaw<null, void>(`${import.meta.env.VITE_BACKEND_URL}/sanctum/csrf-cookie`, {
            withCredentials: true,
        });
    }
}

export const sanctumApi = new SanctumApi();
